export default __webpack_public_path__ + "img/cAneiPSG.9962ebe8.svg";